module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModal),
      expression: "closeModal"
    }],
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "modal-inner-vertical",
    staticStyle: {
      "border-right": "0.5px solid lightgray"
    }
  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    staticClass: "input-form",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "'DINPro Bold'"
    }
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', {
    staticStyle: {
      "font-family": "'DINPro Light'",
      "color": "white"
    }
  }, [_vm._v("\n            Drag your file(s) here to begin\n            "), _c('br'), _vm._v("or click to browse\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": "white",
      "indeterminate": ""
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "80%",
      "max-width": "30rem"
    },
    attrs: {
      "src": _vm.fileUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-inner-vertical",
    staticStyle: {
      "border-right": "0.5px solid lightgray"
    }
  }, [_c('div', {
    staticClass: "input-save-container"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Title",
      "required": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "2rem"
    },
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.catagories,
      "item-text": "title",
      "item-value": "_id",
      "label": "Catagory",
      "solo": ""
    },
    model: {
      value: (_vm.catagory),
      callback: function($$v) {
        _vm.catagory = $$v
      },
      expression: "catagory"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-container"
  }, [_c('v-switch', {
    attrs: {
      "label": ("Awarded: " + (_vm.isAward.toString()))
    },
    model: {
      value: (_vm.isAward),
      callback: function($$v) {
        _vm.isAward = $$v
      },
      expression: "isAward"
    }
  }), _vm._v(" "), (_vm.isAward) ? _c('v-text-field', {
    attrs: {
      "label": "Award Title"
    },
    model: {
      value: (_vm.awardTitle),
      callback: function($$v) {
        _vm.awardTitle = $$v
      },
      expression: "awardTitle"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "2rem"
    },
    attrs: {
      "color": "primary",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveJewelry
    }
  }, [_vm._v("Save")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdee7fa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/modals/AddJewelry.vue
// module id = 223
// module chunks = 1